import { Link } from "react-router-dom";
import { Home, ArrowLeft } from "lucide-react";
import Footer from "../components/Footer";

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-[#F8FAFF]">
      <div className="max-w-4xl mx-auto px-4 md:px-6 pt-16 md:pt-20 pb-24 md:pb-32">
        <div className="text-center mb-12 md:mb-16 pt-6 md:pt-10">
          <h1 className="text-3xl md:text-5xl lg:text-6xl mb-4 md:mb-6 font-medium">Terms of Service</h1>
          <p className="text-base md:text-xl text-gray-600 max-w-3xl mx-auto font-light">
            I nostri termini e condizioni di utilizzo
          </p>
        </div>

        <div className="bg-white rounded-2xl p-6 md:p-8 shadow-sm">
          <div className="prose prose-gray max-w-none">
            <div className="space-y-6 text-gray-700 leading-relaxed">
              <p className="text-sm text-gray-500 mb-8">
                <strong>Ultimo aggiornamento:</strong> 15 luglio 2025
              </p>
              
              <p>Benvenuto sul sito [inserisci il dominio del sito web] (di seguito, il &quot;Sito&quot;). Il presente documento descrive i termini e le condizioni di utilizzo del Sito. Accedendo o utilizzando questo Sito, accetti di essere vincolato dai presenti Termini di Servizio.</p>

              <div>
                <h2 className="text-xl font-semibold mb-3 text-gray-900">1. Titolare del Sito</h2>
                <p>Questo Sito è gestito da:</p>
                <p className="ml-4">
                  Denis Bartolomei<br />
                  Email: denis.bartolomei@gmail.com
                </p>
              </div>

              <div>
                <h2 className="text-xl font-semibold mb-3 text-gray-900">2. Descrizione del Servizio</h2>
                <p>Il Sito ha finalità esclusivamente informative e di presentazione. Gli utenti possono compilare un modulo di contatto per richiedere informazioni o ricevere un link a una demo dei servizi descritti.</p>
                <p className="mt-3">Non è previsto alcun acquisto diretto né sottoscrizione di servizi a pagamento tramite il Sito.</p>
              </div>

              <div>
                <h2 className="text-xl font-semibold mb-3 text-gray-900">3. Utilizzo del Sito</h2>
                <p>Accedendo al Sito, l&apos;utente si impegna a:</p>
                <ul className="list-disc list-inside ml-4 space-y-1 mt-2">
                  <li>Utilizzarlo solo per scopi leciti e conformi alla legge applicabile;</li>
                  <li>Non compiere azioni che possano compromettere, danneggiare o interferire con il funzionamento del Sito;</li>
                  <li>Non tentare di ottenere accesso non autorizzato a server, sistemi o dati connessi al Sito.</li>
                </ul>
              </div>

              <div>
                <h2 className="text-xl font-semibold mb-3 text-gray-900">4. Raccolta dei Dati</h2>
                <p>Tramite il modulo presente nel Sito, è possibile lasciare un indirizzo email. Questo dato verrà utilizzato esclusivamente per contattare l&apos;utente e/o inoltrare il link a una demo.</p>
                <p className="mt-3">Per ulteriori informazioni su come i dati vengono gestiti, ti invitiamo a consultare la Privacy Policy.</p>
              </div>

              <div>
                <h2 className="text-xl font-semibold mb-3 text-gray-900">5. Proprietà Intellettuale</h2>
                <p>Tutti i contenuti presenti nel Sito (testi, loghi, grafiche, marchi, immagini) sono di proprietà esclusiva di Denis Bartolomei o dei rispettivi licenziatari. È vietata la riproduzione, distribuzione, modifica o utilizzo non autorizzato dei contenuti senza consenso scritto del Titolare.</p>
              </div>

              <div>
                <h2 className="text-xl font-semibold mb-3 text-gray-900">6. Limitazione di Responsabilità</h2>
                <p>Il Sito è fornito &quot;così com&apos;è&quot;. Il Titolare non garantisce che il Sito sia privo di errori o che l&apos;accesso sia continuo, sicuro o privo di interruzioni.</p>
                <p className="mt-3">In nessun caso il Titolare potrà essere ritenuto responsabile per danni diretti, indiretti o consequenziali derivanti dall&apos;uso o dall&apos;impossibilità di utilizzare il Sito.</p>
              </div>

              <div>
                <h2 className="text-xl font-semibold mb-3 text-gray-900">7. Modifiche ai Termini</h2>
                <p>Il Titolare si riserva il diritto di modificare in qualsiasi momento i presenti Termini. Le modifiche avranno effetto dal momento della pubblicazione sul Sito. È responsabilità dell&apos;utente consultare periodicamente questa pagina.</p>
              </div>

              <div>
                <h2 className="text-xl font-semibold mb-3 text-gray-900">8. Legge Applicabile e Foro Competente</h2>
                <p>I presenti Termini sono regolati dalla legge italiana. Per qualsiasi controversia derivante dall&apos;utilizzo del Sito, sarà competente in via esclusiva il Foro di Milano, salvo diversa disposizione inderogabile di legge.</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Navigation */}
      <div className="fixed bottom-4 md:bottom-8 left-1/2 transform -translate-x-1/2 flex gap-3 md:gap-6 z-50 bg-white/80 backdrop-blur-sm px-3 py-3 md:px-6 md:py-3 rounded-full shadow-md">
        <Link to="/" className="w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-gray-200 hover:bg-gray-300 transition-colors duration-300">
          <Home size={14} className="md:w-4 md:h-4" />
        </Link>
        <Link to="/" className="px-3 md:px-5 h-8 md:h-10 flex items-center justify-center rounded-full bg-gray-200 hover:bg-gray-300 transition-colors duration-300">
          <ArrowLeft size={12} className="md:w-3 md:h-3 mr-1" />
          <span className="text-xs font-medium">Indietro</span>
        </Link>
      </div>
      
      <Footer />
    </div>
  );
};

export default TermsOfService;